export const getWindowHeight = () => document.body.clientHeight;
